function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.44 13.462a.915.915 0 011.464-1.095 3.655 3.655 0 005.513.395l2.73-2.733a3.66 3.66 0 00-.044-5.128 3.65 3.65 0 00-5.115-.054L12.416 6.41a.914.914 0 11-1.289-1.297L12.71 3.54a5.48 5.48 0 017.686.067 5.494 5.494 0 01.056 7.704l-2.742 2.744a5.481 5.481 0 01-8.269-.593zm5.12-2.924a.915.915 0 01-1.464 1.095 3.655 3.655 0 00-5.513-.395l-2.73 2.733a3.66 3.66 0 00.044 5.128 3.65 3.65 0 005.113.056l1.563-1.564a.914.914 0 111.293 1.293L11.29 20.46a5.48 5.48 0 01-7.686-.067 5.494 5.494 0 01-.056-7.704L6.29 9.945a5.481 5.481 0 018.269.593z"
});

var SvgLink = function SvgLink(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/link.cf6204d1.svg";
export { SvgLink as ReactComponent };